import TeamStatistics from 'components/general/TeamStatistics'
import Accordion from 'react-bootstrap/Accordion';
import SportCode from 'components/common/SportCode'
import MirsTable from 'components/general/table/Table.js';
import Label from "components/general/Label";
import { useMemo } from 'react';
import { findArray } from 'helpers/utils';
import Competitor from "components/presentation/Competitor";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


const getPeriodOrder = (periodsOrder, period) => {
    return periodsOrder?.find(i => i.period === period)?.order;
}

const RenderPeriods = ({ data, statsTOT, statsSet, statsExt, periods, periodsOrder }) => {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    return periods?.map(item => {
        let currPeriod = item.p_code
        return (
            <Accordion.Item id={`mirs-accordion-item-${item.p_code}`} eventKey={item.p_code} key={item.p_code}>
                <Accordion.Header><SportCode discipline={mirs_discipline} entity='@Period' code={item.p_code} /></Accordion.Header>
                <Accordion.Body>
                    {currPeriod === 'TOT'
                        ? (<>
                            <TeamStatistics data={data?.results} stats={statsTOT} currPeriod={currPeriod} />
                            <RenderExtraTable data={data} stats={statsExt} />
                        </>)
                        : <TeamStatistics data={data?.results} stats={statsSet} currPeriod={currPeriod} />
                    }
                </Accordion.Body>
            </Accordion.Item>
        )
    }
    )
}

const RenderExtraTable = ({ data, stats }) => {
    const { mirs_rsc } = useUrlFriendlyToParameters()
    const tableColumns = useMemo(() =>
        [
            {
                id: 'ExtendedInfo',
                accessor: 'code',
                className: 'text-start w-40',
                Cell: (props) => {
                    let row = props.cell.row.original
                    let label = row.header ? row.header : <></>
                    return (
                        <>{label}</>
                    )
                }
            },
            {
                id: 'TeamsHome',
                className: 'text-center w-30',
                Cell: (props) => {
                    let athleteList = findArray(data?.results?.items, { startSortOrder: [1] })?.teamAthletes;
                    let code = props.cell.row.original.code
                    switch (code) {
                        case "SPEED":
                            let athleteSpeedValue
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SPEED")) {
                                    athleteSpeedValue = ath
                                }
                            })
                            return <>{findArray(athleteSpeedValue?.statsItems, { code: ['SPEED'] }).value}<Label data="LabelKMH" /></>
                        case "SPEED_N":
                            let athleteSpeed
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SPEED")) {
                                    athleteSpeed = ath
                                }
                            })
                            return <Competitor {...athleteSpeed?.athlete} noLink={true} hidePicture={true} hideNoc={true} />
                        case "SCORE":
                            let athleteScoreValue
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SCR" && res.rank === "1")) {
                                    athleteScoreValue = ath
                                }
                            })
                            return <>{findArray(athleteScoreValue?.statsItems, { code: ['SCR'] }, { pos: ['TOT'] }).value}/
                                {findArray(athleteScoreValue?.statsItems, { code: ['SCR'] }, { pos: ['TOT'] }).attempt}</>
                        case "SCORE_N":
                            let athleteScore
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SCR" && res.rank === "1")) {
                                    athleteScore = ath
                                }
                            })
                            return <Competitor {...athleteScore?.athlete} noLink={true} hidePicture={true} hideNoc={true} />
                        default:
                            return <></>
                    }
                },
            },
            {
                id: 'TeamsAway',
                className: 'text-center w-30',
                Cell: (props) => {
                    let athleteList = findArray(data?.results?.items, { startSortOrder: [2] })?.teamAthletes;
                    let code = props.cell.row.original.code
                    switch (code) {
                        case "SPEED":
                            let athleteSpeedValue
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SPEED")) {
                                    athleteSpeedValue = ath
                                }
                            })
                            return <>{findArray(athleteSpeedValue?.statsItems, { code: ['SPEED'] }).value}<Label data="LabelKMH" /></>
                        case "SPEED_N":
                            let athleteSpeed
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SPEED")) {
                                    athleteSpeed = ath
                                }
                            })
                            return <Competitor {...athleteSpeed?.athlete} noLink={true} hidePicture={true} hideNoc={true} />
                        case "SCORE":
                            let athleteScoreValue
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SCR" && res.rank === "1")) {
                                    athleteScoreValue = ath
                                }
                            })
                            return <>{findArray(athleteScoreValue?.statsItems, { code: ['SCR'] }, { pos: ['TOT'] }).value}/
                                {findArray(athleteScoreValue?.statsItems, { code: ['SCR'] }, { pos: ['TOT'] }).attempt}</>
                        case "SCORE_N":
                            let athleteScore
                            athleteList?.forEach(ath => {
                                if (ath?.statsItems.find(res => res.code === "SCR" && res.rank === "1")) {
                                    athleteScore = ath
                                }
                            })
                            return <Competitor {...athleteScore?.athlete} noLink={true} hidePicture={true} hideNoc={true} />
                        default:
                            return <></>
                    }
                },
            }
        ], [data]
    )
    return (
        <MirsTable
            id={`mirs-table-team-statistics-${mirs_rsc}`}
            data={stats}
            columns={tableColumns}
            showLoading={false}
        />
    )
}

function VvoTeamStats({ data, periodsOrder }) {
    const handleClick = (e) => {
        // console.log(e);
    }

    const statsTOT = [
        { code: 'RCP' },
        { code: 'SET' },
        { code: 'DIG' },
        { code: 'SCR', component: 'type7' },
        { code: 'OPP_ERR' },
        { code: 'SRV', component: 'type7' },
        { code: 'BLC', component: 'type7' },
        { code: 'SPK', component: 'type7' }
    ]

    //Added because the SCR doesn't have value and attempt for single sets. Might need to be reviewed
    const statsSet = [
        { code: 'RCP' },
        { code: 'SET' },
        { code: 'DIG' },
        { code: 'SCR' },
        { code: 'OPP_ERR' },
        { code: 'SRV', component: 'type7' },
        { code: 'BLC', component: 'type7' },
        { code: 'SPK', component: 'type7' }
    ]

    const statsExt = [
        { code: 'SPEED' },
        { code: 'SPEED_N', header: 'Fastest Serve' },
        { code: 'SCORE' },
        { code: 'SCORE_N', header: 'Best Scorer' },

    ]

    let periods = data?.results?.periods
    periods?.sort((a, b) => getPeriodOrder(periodsOrder, b.p_code) - getPeriodOrder(periodsOrder, a.p_code));

    return (<>
        <Accordion defaultActiveKey={periods[0].p_code} onClick={(e) => handleClick(e)}>
            <RenderPeriods data={data} statsTOT={statsTOT} statsSet={statsSet} statsExt={statsExt} periods={periods} periodsOrder={periodsOrder} />
        </Accordion>
    </>);
}

export default VvoTeamStats;